module.exports = __webpack_public_path__ + "247c39cc276a6a04ded43a7135b44053.pdf";